"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var catalog_exports = {};
__export(catalog_exports, {
  Catalog: () => Catalog
});
module.exports = __toCommonJS(catalog_exports);
var Catalog;
((Catalog2) => {
  let Bundle;
  ((Bundle2) => {
    Bundle2.path = "bundle";
  })(Bundle = Catalog2.Bundle || (Catalog2.Bundle = {}));
  let CategoryProducts;
  ((CategoryProducts2) => {
    CategoryProducts2.path = "categoryProducts";
  })(CategoryProducts = Catalog2.CategoryProducts || (Catalog2.CategoryProducts = {}));
  let Ci;
  ((Ci2) => {
    Ci2.path = "catalog/ci";
  })(Ci = Catalog2.Ci || (Catalog2.Ci = {}));
  let FindAlternate;
  ((FindAlternate2) => {
    FindAlternate2.path = "findAlternate";
  })(FindAlternate = Catalog2.FindAlternate || (Catalog2.FindAlternate = {}));
  let Find;
  ((Find2) => {
    Find2.path = "find";
  })(Find = Catalog2.Find || (Catalog2.Find = {}));
  let Load;
  ((Load2) => {
    Load2.path = "load";
  })(Load = Catalog2.Load || (Catalog2.Load = {}));
  let Meta;
  ((Meta2) => {
    Meta2.path = "meta";
  })(Meta = Catalog2.Meta || (Catalog2.Meta = {}));
  let Route;
  ((Route2) => {
    Route2.path = "route";
  })(Route = Catalog2.Route || (Catalog2.Route = {}));
})(Catalog || (Catalog = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Catalog
});
